function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Info Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Info-Icon",
  transform: "translate(-1.000000, -1.000000)",
  fill: "#002645"
}, React.createElement("g", {
  transform: "translate(1.000000, 1.000000)",
  id: "Shape"
}, React.createElement("path", {
  d: "M17,34 C7.61115925,34 0,26.3888407 0,17 C0,7.61115925 7.61115925,0 17,0 C26.3888407,0 34,7.61115925 34,17 C34,26.3888407 26.3888407,34 17,34 Z M18.7382812,6.68261719 C18.1425751,6.68261719 17.6372091,6.89257603 17.222168,7.3125 C16.8071268,7.73242397 16.5996094,8.2402314 16.5996094,8.8359375 C16.5996094,9.4316436 16.8095682,9.93945103 17.2294922,10.359375 C17.6494162,10.779299 18.1523408,10.9892578 18.7382812,10.9892578 C19.3339874,10.9892578 19.8417948,10.779299 20.2617188,10.359375 C20.6816427,9.93945103 20.8916016,9.4316436 20.8916016,8.8359375 C20.8916016,8.2402314 20.6840841,7.73242397 20.269043,7.3125 C19.8540018,6.89257603 19.343753,6.68261719 18.7382812,6.68261719 Z M19.6464844,13.4208984 L18.7675781,13.4208984 L13.8017578,14.2265625 L13.6113281,14.8125 C13.8164073,14.8027343 13.9921868,14.7978516 14.1386719,14.7978516 C14.4609391,14.7978516 14.7148428,14.8808585 14.9003906,15.046875 C15.0859384,15.2128915 15.1787109,15.4033192 15.1787109,15.6181641 C15.1787109,15.9599626 15.0810557,16.4677701 14.8857422,17.1416016 L12.8496094,24.1435547 C12.6835929,24.7001981 12.6005859,25.1591779 12.6005859,25.5205078 C12.6005859,26.0673855 12.7885723,26.5190412 13.1645508,26.8754883 C13.5405292,27.2319354 14.0458953,27.4101562 14.6806641,27.4101562 C16.3408286,27.4101562 17.9081958,26.1259894 19.3828125,23.5576172 L18.8847656,23.2646484 C18.2695282,24.2119188 17.7421897,24.8662091 17.3027344,25.2275391 C17.1367179,25.3740242 16.970704,25.4472656 16.8046875,25.4472656 C16.7070308,25.4472656 16.6142583,25.4008794 16.5263672,25.3081055 C16.4384761,25.2153316 16.3945312,25.1152349 16.3945312,25.0078125 C16.3945312,24.8222647 16.4775382,24.4316436 16.6435547,23.8359375 L19.6464844,13.4208984 Z"
}))));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.8725abe2.svg";
export { ForwardRef as ReactComponent };